import { ConnectedBankAccount } from "Components/Users/ConnectedBankAccounts/ConnectedBankAccount";
import {
  type AmountDto,
  type BankAccountListItem,
  BankAccountStatus,
  type BankVerificationSource,
  CurrencyCode,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import {
  BANK_CODE_TO_BANK,
  BANK_TO_ENVIRONMENT,
  getBankCodeFromIBAN,
} from "Utils/AccountUtils";
import { toast } from "sonner";

const NO_LIMIT_AMOUNT: AmountDto = { value: 0, currencyCode: CurrencyCode.CZK };

type Props = {
  userID: number;
  verifiedIBAN: string;
  bankVerificationSource?: BankVerificationSource | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
  bankVerificationDate?: string | null;
};

export const DeletedVerificationAccount = ({
  userID,
  verifiedIBAN,
  bankVerificationSource,
  bankVerificationDate,
  companyName,
  firstName,
  lastName,
}: Props) => {
  const { t } = useResource();
  const bankCode = getBankCodeFromIBAN(verifiedIBAN);
  const bank = BANK_CODE_TO_BANK[bankCode];

  if (!bank) {
    toast.error(
      t(Resources.Pages.Content.BankAccounts.DeletedVerificationAccount.Error),
    );
    return null;
  }

  const accountName = companyName || `${firstName} ${lastName}`;
  const dummyAccount: BankAccountListItem = {
    bankAccountID: 0,
    bank,
    productName: accountName,
    iban: verifiedIBAN,
    environment: BANK_TO_ENVIRONMENT[bank],
    currency: "CZK",
    isPrimary: false,
    status: BankAccountStatus.Inactive,
    dateCreated: bankVerificationDate || "",
    ownersNames: [accountName],
    balance: 0,
    rank: 0,
    publicID: "",
    isReceiveOnly: true,
    isTokenInvalid: false,
    paymentLimits: {
      hasLimit: false,
      preApprovalRemainingAmount: NO_LIMIT_AMOUNT,
      preApprovalTotalLimit: NO_LIMIT_AMOUNT,
      preApprovalOneTimeLimit: NO_LIMIT_AMOUNT,
    },
  };

  return (
    <ConnectedBankAccount
      bankAccount={dummyAccount}
      userID={userID}
      verifiedIBAN={verifiedIBAN}
      bankVerificationSource={bankVerificationSource}
    />
  );
};
